import { apiClient, type components } from '@boothiva/api-client';

export type PlatformTenant = components['schemas']['PlatformTenantSummary'];
export type PlatformTenantPage = components['schemas']['PlatformTenantPage'];
export type TenantFilters = { page: number; pageSize: number; q?: string; status?: string };
export type TenantSubscription = components['schemas']['TenantSubscriptionResponse'];
export type ChangeTenantPlanRequest = components['schemas']['ChangeTenantPlanRequest'];
export type TenantUsageSummary = components['schemas']['TenantUsageSummaryResponse'];
export type TenantStatus = components['schemas']['TenantStatusResponse'];
export type SuspendTenantRequest = components['schemas']['SuspendTenantRequest'];
export type MarkTenantCompedRequest = components['schemas']['MarkTenantCompedRequest'];
export type SubscriptionCompStatus = components['schemas']['SubscriptionCompStatusResponse'];

export function listTenants(filters: TenantFilters) {
  const query = new URLSearchParams({ page: String(filters.page), pageSize: String(filters.pageSize) });
  if (filters.q) query.set('q', filters.q);
  if (filters.status) query.set('status', filters.status);
  return apiClient.get<PlatformTenantPage>(`/api/v1/platform/tenants?${query}`);
}

export const getTenantSubscription = (tenantId: string) =>
  apiClient.get<TenantSubscription>(`/api/v1/platform/tenants/${tenantId}/subscription`);
export const changeTenantPlan = (tenantId: string, request: ChangeTenantPlanRequest) =>
  apiClient.put<TenantSubscription>(`/api/v1/platform/tenants/${tenantId}/subscription/plan`, request);
export const getTenantUsage = (tenantId: string) =>
  apiClient.get<TenantUsageSummary>(`/api/v1/platform/tenants/${tenantId}/usage`);
export const reactivateTenant = (tenantId: string) =>
  apiClient.post<TenantStatus>(`/api/v1/platform/tenants/${tenantId}/reactivate`);
export const suspendTenant = (tenantId: string, request: SuspendTenantRequest) =>
  apiClient.post<TenantStatus>(`/api/v1/platform/tenants/${tenantId}/suspend`, request);
export const cancelSubscription = (tenantId: string) =>
  apiClient.post<TenantSubscription>(`/api/v1/platform/tenants/${tenantId}/subscription/cancel`);
export const resumeSubscription = (tenantId: string) =>
  apiClient.post<TenantSubscription>(`/api/v1/platform/tenants/${tenantId}/subscription/resume`);
export const clearTenantStripeIds = (tenantId: string) =>
  apiClient.post<TenantSubscription>(`/api/v1/platform/tenants/${tenantId}/subscription/clear-stripe-ids`);
export const markTenantComped = (tenantId: string, request: MarkTenantCompedRequest) =>
  apiClient.post<SubscriptionCompStatus>(`/api/v1/platform/tenants/${tenantId}/comp`, request);
export const removeTenantComp = (tenantId: string) =>
  apiClient.post<SubscriptionCompStatus>(`/api/v1/platform/tenants/${tenantId}/uncomp`);
